export default "__VITE_ASSET__BnqIC9pM__"